import { FC } from "react";
import PdfViewer from "@/components/pdf-viewer/PdfViewer";

const RvltPage: FC = () => {
  return <PdfViewer pdfPath="/assets/rvlt.pdf" title="RVLT Rules" />;
};

export default RvltPage;
